export default class CurrentOrganizationStatistics {
    constructor (dto) {
        this.id = -1;
        this.logo = '';
        this.name = '';
        this.totalDocuments = 0;
        this.totalSignedDocuments = 0;
        this.totalContentTypes = 0;
        this.totalUsedSpace = 0;
        this.totalUsedSpaceDisplay = '';
        this.maxUsedSpace = 0;
        this.maxUsedSpaceDisplay = '';
        this.totalUsers = 0;
        this.totalFullUsers = 0;
        this.maxFullUsers = 0;
        this.totalReadonlyUsers = 0;
        this.maxReadonlyUsers = 0;
        this.totalConcurrentUsers = 0;
        this.maxConcurrentUsers = 0;
        this.total2FAUsers = 0;
        this.max2FAUsers = 0;
        this.totalDevices = 0;
        this.maxDevices = 0;
        this.autorecognitionEnabled = false;

        if (dto) {
            Object.keys(dto).forEach((key) => {
                this[key] = dto[key];
            });
        }
    }
}